import UserRoleManagement from './UserRoleManagement';

export default UserRoleManagement;
